module.exports = __webpack_public_path__ + "static/2_Train_2208x1242.ae3487f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/2_Train_2208x1242.png
// module id = 1159
// module chunks = 35783957827783